//const Backofficebff         : string = "/backofficebff/service/api/v1";
const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;
const regionId: any = JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.regionId;
export const MenuQuery: any = {
    GetMenuList: Backofficebff + '/v1/generals/leftmenu',
    GetMenuItemsByParent: Backofficebff + '/v1/menu/items-byparent?parentMenuId=0&regionId=' + regionId,
    GetMenuAll: Backofficebff + '/v1/menu/all?regionId=' + regionId,
    GetMenuRoleList: Backofficebff + '/v1/menu/item-role/list',
    GetMenuAllEndPoints: Backofficebff + '/v1/menu/allendpoints',
    GetMenuApplicationList: Backofficebff + '/v1/menu/menu-application/list',
    GetMenuApplicationByAppId: Backofficebff + '/v1/menu/menu-application/',
};
